<template>
    <el-dialog
        title="确认状态推送BMS"
        :visible="true"
        width="900px"
        append-to-body
        :custom-class="'confirmStatusDialog'"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose">
        <table-box
            ref="tablePage"
            :columns="tableConfig.columns"
            :height="tableConfig.height"
            :loading="loading"
            :rows="tableData"
            :actions="tableConfig.action"
            @action-click="actionClick"
        >
        </table-box>
    </el-dialog>
</template>

<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import { getPushBmsResult, rePushBms } from '../../../../api/driverExpenseManage.js';
export default {
    components: { tableBox },
    props: {
        confirmStatusDialogShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data() {
        return {
            tableConfig: {
                leftOperation: true,
                leftWidth: 100,
                height: 200,
                columns: [
                    {
                        label: '推送类型',
                        prop: 'frozenStateName',
                        sort: true,
                        width: 150
                    },
                    {
                        label: '推送时间',
                        prop: 'pushTime',
                        sort: true,
                        width: 150
                    },
                    {
                        label: '推送结果',
                        prop: 'pushFlagName',
                        sort: true,
                        width: 200
                    },
                    {
                        label: '失败原因',
                        prop: 'failReason',
                        sort: true,
                        width: 200
                    }
                ],
                action: {
                    fixedWidth: 100,
                    list: [
                        {
                            type: 'text',
                            label: '重推',
                            size: 'mini',
                            event: 'rePush',
                            displayRule: row => {
                                return !row.pushFlag;
                            }
                        }
                    ]
                }
            },
            tableData: [],
            loading: false
        };
    },
    mounted () {
        this.queryPushDetail();
    },
    methods: {
        beforeClose() {
            this.$emit('refresh', 'confirmStatusDialogShow');
        },
        queryPushDetail () {
            if (!this.componentsData.dispatchNo) return;
            this.loading = true;
            getPushBmsResult({ dispatchNo: this.componentsData.dispatchNo })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = this.formatTableData(res.data || []);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatTableData (data) {
            if (!data.length) return [];
            data.forEach(item => {
                item.frozenStateName = this.dictData.PUSH_TYPE[item.frozenState] || '';
                item.pushFlagName = this.dictData.PUSH_BMS_FLAG[item.pushFlag] || '';
            });
            return data;
        },
        /**
        * @description 操作列事件处理
        * @event {事件类型} rePush 重推
        * @row   {Object} 行数据
       */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'rePush':
                    this.handleRePush(row);
                    break;
                default:
                    break;
            }
        },
        handleRePush (rowData) {
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                sourceType: '30', // 固定传参：LSP
                frozenState: rowData.frozenState,
                confirmId: rowData.confirmId,
                id: rowData.id
            };
            this.loading = true;
            rePushBms(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.queryPushDetail();
                });
        }
    }
};
</script>

<style lang="less">
.confirmStatusDialog {
    .el-dialog__body {
        .el-table--border {
            border-right: 1px solid #EBEEF5;
            border-bottom: 1px solid #EBEEF5;
        }
    }
}
</style>
